module.exports = __webpack_public_path__ + "img/11_107.0d23f16a.png";